import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "loading"
}
const _hoisted_5 = {
  key: 2,
  class: "error"
}
const _hoisted_6 = { key: 3 }

import axios from "@/axiosInstance";
import { API_URL } from "@/config";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";

/* quale pagina aprire dopo la scelta / creazione */

export default /*@__PURE__*/_defineComponent({
  __name: 'DevicePickerModal',
  props: {
    target: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const headerLabel =
	props.target === "Editor" ? "Apri in Editor" : "Apri in Data";
/* flag per creazione nuovo device solo se si clicca Editor */
const canCreate = props.target === "Editor";

const emit = __emit;
const router = useRouter();
const toast = useToast();

const devices = ref<any[]>([]);
const loading = ref(false);
const error = ref<string | null>(null);

/* ─── carica lista esistente ─── */
async function loadDevices() {
	loading.value = true;
	try {
		const { data } = await axios.get("/devices/get-all-graphs", {
			withCredentials: true,
		});
		// mostriamo i devices filtrando i device archiviati (is_archived = true)
		devices.value = (data ?? []).filter((g: any) => g.is_archived === false);
	} catch (e: any) {
		error.value = e.response?.data?.details || "Errore caricamento";
	} finally {
		loading.value = false;
	}
}

onMounted(loadDevices);

/* ─── seleziona ─── */
function selectDevice(id: number) {
	emit("close");
	router.push({ name: props.target, params: { deviceId: id } });
}

/* ─── crea nuovo ─── */
async function createDevice() {
	if (!canCreate) return;

	try {
		const newDevice = await axios.post(`${API_URL}/devices/new-device`);
		toast.success(
			`Nuovo Device con id: ${newDevice.data.id} aggiunto con successo`,
			{
				position: "top-right",
				duration: 2000,
			},
		);

		emit("close"); // chiudi modal
		/* per un nuovo device ha senso andare subito in EDITOR:               *
		 * se invece vuoi rispettare il target basta sostituire props.target  */
		router.push({ name: "Editor", params: { deviceId: newDevice.data.id } });
	} catch {
		toast.error("Errore nella creazione", {
			position: "top-right",
			duration: 2000,
		});
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mask",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("h2", null, _toDisplayString(_unref(headerLabel)), 1),
        _createElementVNode("button", {
          class: "x",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      (!loading.value)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(devices.value, (d) => {
              return (_openBlock(), _createElementBlock("li", {
                key: d.id
              }, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (selectDevice(d.id))
                }, [
                  _createElementVNode("strong", null, "#" + _toDisplayString(d.id), 1),
                  _createTextVNode(" · " + _toDisplayString(d.name || "— senza nome —"), 1)
                ], 8, _hoisted_3)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "Caricamento…")),
      (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(error.value), 1))
        : _createCommentVNode("", true),
      canCreate
        ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
            _createElementVNode("button", {
              class: "create",
              onClick: createDevice
            }, "+ Nuovo device")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})